<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <!--          <va-button flat ouline color="red" >1. 请务必按照示例的格式上传，每个excel中只能存在一个sheet，不要重复上传同一个文件</va-button>-->
          <!--          <va-button flat ouline color="red" >2. 上传成功后，下方列表可以查看从该文件中读取到的内容，如果有错误的，可以直接删除</va-button>-->
          <!--          <va-button flat ouline color="red" >3. 审核完毕后，点击一键发布，期间不要刷新或者切换其他页面</va-button>-->
          <!--          <va-button flat ouline color="red" >4. 如果步骤3操作失误，那么直接点击返回练习题列表，可在草稿中查看刚上传的练习题</va-button>-->
          <div class='flex md12 sm6 xs12'>
            <a href="https://static.libaspace.com/image/20230125/f15d7706b666492e874eda8e3fc6fee8.pdf" target="_Blank">
              <va-button class="ma-0" color="primary" slot="trigger">
                查看示例<!--{{insertData.fileName}}-->
              </va-button>
            </a>
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input
              v-model='insertData.prefix'
              label='题号前缀'
              placeholder="比如Q,如果没有就不填"
            />
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input
              v-model='insertData.suffix'
              label='题号前缀'
              placeholder="比如'.', ':', ')',如果没有就不填"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.organization"
              label="企业名称"
              single
              :messages="message"
              :error="!!error.organizationErrors.length"
              :error-messages="error.organizationErrors"
              :options="organizations.map(x=>x.name)"
              searchable
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.positionTag"
              label="职位类型"
              :messages="message"
              :error="!!error.positionTagsErrors.length"
              :error-messages="error.positionTagsErrors"
              :options="positionTags.map(x=>x.name)"
              searchable
            />
          </div>
          <!--          https://static.libaspace.com/image/20221218/31558764253e487da08d6408bdef97df.xlsx-->
          <div class="flex md12 sm6 xs12">
            <va-card title='封面展示图'>
              <va-file-upload
                type='single'
                dropzone="dropzone"
                v-model='insertData.pdfArr'
              />
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='errorMsg'
              label='处理结果'
              disabled
            />
          </div>
        </div>
        <div class="row justify--center">
          <div class="flex mb-2 justify--center">
            <va-button color="info" slot="trigger" @click="uploadPdf" :disabled="!submitButtonStatus">
              上传
            </va-button>
          </div>
          <div class="flex mb-2 justify--center">
            <va-button color="gray" slot="trigger" @click="$router.push({ name: 'listPracticeQuestion'})">
              返回练习题列表
            </va-button>
          </div>
        </div>
      </va-card>
    </div>
    <div class="flex xs10 offset--xs1">
      <va-card title="临时列表(刷新页面后就会清空)">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm12">
            <div class="d-flex justify--end">
              <va-button color="info" small @click="publishModal=true" :disabled="practiceQuestions.length === 0">一键发布</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="practiceQuestions"
          :loading="loading"
          api-mode
        >
          <template slot="questionTags" slot-scope="props">
            <div v-for="tag in props.rowData.questionTags" :key="tag">
              {{tag}}
            </div>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal=true;deleteId=props.rowData.id"/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除练习题"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />
        <va-modal
          v-model="publishModal"
          title="一键发布"
          okText="提交"
          position="center"
          message="请确认已经全部审核完毕？"
          @ok="confirmPublish"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import uploadApi from '@/api/upload'
import organizationApi from '@/api/organization'
import { INTERVIEW_TAG_TYPE } from '@/utils/constants'
import positionTagApi from '@/api/interview/positionTag'
import practiceQuestionApi from '@/api/interview/practiceQuestion'

export default {
  data () {
    return {
      insertData: {
        pdfArr: [],
        organization: '',
        positionTag: '',
        prefix: '',
        suffix: '',
      },
      message: ['Required field'],
      error: {
        positionTagsErrors: [],
        organizationErrors: [],
      },
      showId: false,
      title: '上传练习题PDF',
      errorMsg: '',
      practiceQuestions: [],
      loading: false,
      deleteId: null,
      deleteModal: false,
      publishModal: false,
      organizations: [],
      positionTags: [],
      submitButtonStatus: true,
    }
  },
  created () {
    this.listOrganization()
    this.listPositionTag()
  },
  computed: {
    formReady () {
      return !this.error.organizationErrors.length &&
          !this.error.positionTagsErrors.length
    },
    fields () {
      return [
        {
          name: 'organization',
          title: '企业名称',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'positionTag',
          title: '职位标签',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'question',
          title: '练习题题目',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'answer',
          title: '练习题答案',
          width: '50%',
          titleClass: 'text-center',
          dataClass: 'text-left',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
    flipOrganization () {
      const flipTags = {}
      this.organizations.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    flipPositionTags () {
      const flipTags = {}
      this.positionTags.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
  },
  methods: {
    clickCancel () {
    },
    uploadPdf () {
      if (this.insertData.pdfArr.length === 0) {
        this.showToast('请上传文件', {
          duration: 10000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      this.errorMsg = '请稍等........'
      const formData = new FormData()
      formData.append('file', this.insertData.pdfArr[this.insertData.pdfArr.length - 1])
      formData.append('positionTagId', this.flipPositionTags[this.insertData.positionTag])
      formData.append('organizationId', this.flipOrganization[this.insertData.organization])
      formData.append('prefix', this.insertData.prefix)
      formData.append('suffix', this.insertData.suffix)
      uploadApi.uploadPDF(formData).then(response => {
        console.log(response)
        this.errorMsg = '上传成功'
        this.practiceQuestions = response.practiceQuestions
        this.showToast('上传成功', {
          duration: 1000,
          icon: 'fa-success',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 10000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        this.errorMsg = error.msg
      })
      this.changeButtonStatus(true)
    },
    listOrganization () {
      this.loading = true
      const params = {
        pageSize: 2000,
        pageNumber: 1,
      }
      organizationApi.listOrganization(params).then(response => {
        this.organizations = response.organizations
        this.loading = false
      }).catch(error => this.showToast('获取公司列表失败: ' + error.msg, {
        duration: 1000,
        icon: 'fa-check',
        position: 'top-center',
        fullWidth: false,
      }))
    },
    listPositionTag () {
      const params = {
        type: INTERVIEW_TAG_TYPE.POSITION_TAG.CODE,
      }
      positionTagApi.listPositionTag(params).then(response => {
        this.positionTags = response.tags
      }).catch(error => this.showToast('获取职位列表失败: ' + error.msg, {
        duration: 1000,
        icon: 'fa-check',
        position: 'top-center',
        fullWidth: false,
      }))
    },
    confirmDelete () {
      if (this.deleteId === null) return
      practiceQuestionApi.deletePracticeQuestion(this.deleteId).then(response => {
        if (response.success === true) {
          const tmp = []
          this.practiceQuestions.forEach(x => {
            if (x.id !== this.deleteId) {
              tmp.push(x)
            }
          })
          this.practiceQuestions = tmp
          this.deleteId = null
          this.showToast('删除成功', {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
        }
      }).catch(error =>
        this.showToast(error.msg, {
          duration: 10000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        }))
    },
    confirmPublish () {
      if (this.practiceQuestions.length === 0) return
      const ids = []
      this.practiceQuestions.forEach(x => {
        ids.push(x.id)
      })
      const data = {
        ids: ids,
      }
      practiceQuestionApi.publishAll(data).then(response => {
        if (response.success === true) {
          this.practiceQuestions = []
          this.showToast('发布成功', {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
        }
      }).catch(error =>
        this.showToast(error.msg, {
          duration: 10000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        }))
    },
    checkField () {
      this.error.organizationErrors = this.insertData.organization ? [] : ['organization is required']
      this.error.positionTagsErrors = this.insertData.positionTag ? [] : ['positionTag is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },

}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
